module.exports = __webpack_public_path__ + "static/media/image1.06eaddf4.svg";